import { render, staticRenderFns } from "./okanAdmin.vue?vue&type=template&id=7e417fbf&"
import script from "./okanAdmin.vue?vue&type=script&lang=js&"
export * from "./okanAdmin.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/okanAdmin.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports